module.exports = __webpack_public_path__ + "img/Dyneff_120X35.70aaebed.png";